import React from 'react';
import { Link } from "react-router-dom";
import "./boatsafari.css";
import { FaShip, FaBinoculars, FaMapMarkedAlt } from "react-icons/fa";

function BoatSafari() {
  const boatSpots = [
    { name: "Madu River", highlight: "Mangrove forest and wildlife", image: "/madu.jpg" },
    { name: "Bentota River", highlight: "Calm waters and birdwatching", image: "/ben-river.jpg" },
    { name: "Negombo Lagoon", highlight: "Fishing villages and scenic views", image: "/negombo-l.jpg" },
  ];

  return (
    <div className="bird-page">
      {/* Banner */}
      <div className="banner-section">
        <img src="/boat-safari.jpg" alt="Boat Safari" className="banner-image" />
        <div className="banner-content">
          <h1 className="banner-title"><span><b>Boat</b></span> Safari</h1>
          <div className="banner-description">
            <p>Embark on a peaceful journey across rivers and lagoons. Spot exotic birds, crocodiles, and enjoy the serenity of nature.</p>
            <Link to="/booking"><button className="book-now-btn">Book Your Boat Safari</button></Link>
          </div>
        </div>
      </div>

      {/* Locations */}
      <div className="wildlife-areas-section">
        <h2 className="section-title">Boat Safari Routes</h2>
        <p className="section-subtitle">Explore Sri Lanka by water</p>
        <div className="wildlife-areas-grid">
          {boatSpots.map((spot, i) => (
            <div className="wildlife-area-card" key={i}>
              <div className="area-image-container">
                <img src={spot.image} alt={spot.name} className="area-image" loading="lazy" />
                <div className="area-overlay"></div>
              </div>
              <div className="area-info">
                <h3>{spot.name}</h3>
                <p>{spot.highlight}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Info Cards */}
      <section className="info-section">
        <div className="info-card"><FaShip className="icon" /><h3 className="desc-heading">River Cruises</h3><p className="desc-para">Relaxing journeys through lush landscapes.</p></div>
        <div className="info-card"><FaBinoculars className="icon" /><h3 className="desc-heading">Wildlife Viewing</h3><p className="desc-para">Spot rare birds and reptiles along the way.</p></div>
        <div className="info-card"><FaMapMarkedAlt className="icon" /><h3 className="desc-heading">Best Routes</h3><p className="desc-para">Explore the most scenic waterways.</p></div>
      </section>

      {/* Quote */}
      <section className="quote-section">
        <blockquote>"A boat is a magic thing. It takes you to places you’d never get to otherwise."</blockquote>
        {/* <cite>— Unknown</cite> */}
      </section>
    </div>
  );
}

export default BoatSafari;
